import { useContext, useEffect, useState } from 'react';

import { MenuMappingContext } from 'components/MenuManagement/MenuEdit/MenuMapping/MenuMapping';
import { Checkbox } from '@mantine/core';

interface RowCheckboxProps {
  rowIdentifier: string;
}

export default function RowCheckbox({ rowIdentifier }: RowCheckboxProps) {
  const { checkedItems, setCheckedItems } = useContext(MenuMappingContext);
  const [isRowChecked, setIsRowChecked] = useState(checkedItems[rowIdentifier] || false);

  useEffect(() => {
    setIsRowChecked(!!checkedItems[rowIdentifier]);
  }, [checkedItems, rowIdentifier]);

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // Uncheck the select all checkbox if it is checked
    const isTargetChecked = e.target.checked;
    // check if this is the only checked item -- mark it as the control item
    if (isTargetChecked && Object.values(checkedItems).every(value => !value)) {
      setCheckedItems({
        control: rowIdentifier,
        [rowIdentifier]: isTargetChecked,
      });
      return;
    }
    // if the control item is unchecked, choose a new control item
    if (!isTargetChecked && checkedItems.control === rowIdentifier) {
      const newControl =
        Object.keys(checkedItems).find(
          otherKey =>
            otherKey !== 'control' && !!checkedItems[otherKey] && otherKey !== rowIdentifier,
        ) || null;
      setCheckedItems({
        ...checkedItems,
        control: newControl,
        [rowIdentifier]: isTargetChecked,
      });
      return;
    }
    setCheckedItems({
      ...checkedItems,
      [rowIdentifier]: isTargetChecked,
    });
  };

  return <Checkbox checked={isRowChecked} onChange={onChange} />;
}
